export default __webpack_public_path__ + "static/media/p_wdt_c_0.de8dc00b.mp3";